// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZA_afa8SzeozXc8kvFZ7{display:flex;gap:var(--spacing-xxxSmall)}.ZA_afa8SzeozXc8kvFZ7 .B2yYMfR3fHHdmefwCsDR{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}`, "",{"version":3,"sources":["webpack://./src/App/components/TableCell/TableCell.module.scss"],"names":[],"mappings":"AAAA,sBAAsB,YAAY,CAAC,2BAA2B,CAAC,4CAAkC,kBAAkB,CAAC,eAAe,CAAC,sBAAsB","sourcesContent":[".table-cell-container{display:flex;gap:var(--spacing-xxxSmall)}.table-cell-container .table-cell{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table-cell-container": `ZA_afa8SzeozXc8kvFZ7`,
	"table-cell": `B2yYMfR3fHHdmefwCsDR`
};
export default ___CSS_LOADER_EXPORT___;
